(function (factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
  if (typeof document !== 'undefined') {
    api.mount();
  }
})(function () {
  var YOUTUBE_ID = /^[A-Za-z0-9_-]{11}$/;
  var VIMEO_ID = /^[0-9]+$/;
  var lockCount = 0;
  var lockedScroll = 0;
  var documentListeners = false;

  function sanitizeExternalId(host, externalId) {
    var id = String(externalId || '');
    if (host === 'youtube' && YOUTUBE_ID.test(id)) return id;
    if (host === 'vimeo' && VIMEO_ID.test(id)) return id;
    return '';
  }

  function externalEmbedUrl(host, externalId) {
    var id = sanitizeExternalId(host, externalId);
    if (!id) return '';
    if (host === 'youtube') {
      return 'https://www.youtube.com/embed/' + id + '?rel=0&modestbranding=1&playsinline=1&autoplay=1';
    }
    return 'https://player.vimeo.com/video/' + id + '?playsinline=1&title=0&byline=0&portrait=0&dnt=1&autoplay=1';
  }

  function formatPosition(template, index, count) {
    return String(template || '')
      .replace(/__INDEX__/g, String(index))
      .replace(/__COUNT__/g, String(count));
  }

  function aspectRatio(video) {
    var aspect = Number(video && video.aspect);
    if (aspect > 0.2 && aspect < 5) return aspect;
    var width = Number(video && video.previewWidth);
    var height = Number(video && video.previewHeight);
    if (width > 0 && height > 0) return width / height;
    return 1.7778;
  }

  function safeImageUrl(url) {
    var value = String(url || '');
    if (value.indexOf('https://') === 0 || value.indexOf('//') === 0) return value;
    return '';
  }

  function safeFileUrl(url) {
    var value = String(url || '');
    if (value.indexOf('https://') === 0) return value;
    if (value.indexOf('//') === 0) return 'https:' + value;
    return '';
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function pauseInlineGallery() {
    document.querySelectorAll('[data-product-gallery] video').forEach(function (video) {
      try { video.pause(); } catch (error) { /* gallery player may already be gone */ }
    });
    document.querySelectorAll('[data-product-gallery] iframe').forEach(function (frame) {
      try {
        frame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        frame.contentWindow.postMessage('{"method":"pause"}', '*');
      } catch (error) { /* cross-origin players ignore unknown commands */ }
    });
  }

  function lockScroll() {
    lockCount += 1;
    if (lockCount !== 1) return;
    lockedScroll = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('gt-videos-lock');
  }

  function unlockScroll() {
    if (lockCount === 0) return;
    lockCount -= 1;
    if (lockCount !== 0) return;
    document.documentElement.classList.remove('gt-videos-lock');
    window.scrollTo(0, lockedScroll);
  }

  function stopOpenViewers(exceptRoot) {
    document.querySelectorAll('[data-gt-product-videos][data-gt-open="true"]').forEach(function (root) {
      if (root !== exceptRoot && root.__gtApi) root.__gtApi.close();
    });
  }

  function mountRoot(root) {
    if (!root) return;
    ensureStylesheet(root);
    if (root.dataset.gtBound === 'true') return;
    var jsonEl = root.querySelector('[data-gt-video-json]');
    var launch = root.querySelector('[data-gt-video-launch]');
    var dialog = root.querySelector('[data-gt-video-dialog]');
    var panel = root.querySelector('[data-gt-video-panel]');
    var frame = root.querySelector('[data-gt-video-frame]');
    var playButton = root.querySelector('[data-gt-video-play]');
    var player = root.querySelector('[data-gt-video-player]');
    var embed = root.querySelector('[data-gt-video-embed]');
    var errorBox = root.querySelector('[data-gt-video-error]');
    var retry = root.querySelector('[data-gt-video-retry]');
    var closeButton = root.querySelector('[data-gt-video-close]');
    var titleEl = root.querySelector('[data-gt-video-current-title]');
    var positionEl = root.querySelector('[data-gt-video-position]');
    var scroller = root.querySelector('[data-gt-video-scroller]');
    var prevButton = root.querySelector('[data-gt-video-scroll="prev"]');
    var nextButton = root.querySelector('[data-gt-video-scroll="next"]');
    if (!jsonEl || !launch || !dialog || !frame || !player || !playButton || !closeButton) return;

    var videos = [];
    try {
      videos = JSON.parse(jsonEl.textContent || '[]');
    } catch (error) {
      videos = [];
    }
    if (!videos.length) return;

    root.dataset.gtBound = 'true';
    var poster = document.createElement('img');
    poster.className = 'gt-product-videos__poster';
    poster.alt = '';
    poster.hidden = true;

    var current = 0;
    var isOpen = false;
    var choicesBuilt = false;
    var lastFocus = null;
    var dialogHome = dialog.parentNode;
    var dialogNext = dialog.nextSibling;
    var choiceButtons = [];

    function reducedBehavior() {
      return prefersReducedMotion() ? 'auto' : 'smooth';
    }

    function showError() {
      if (!errorBox) return;
      errorBox.hidden = false;
      playButton.hidden = true;
    }

    function hideError() {
      if (errorBox) errorBox.hidden = true;
    }

    function stopMedia() {
      player.onerror = null;
      try { player.pause(); } catch (error) { /* already stopped */ }
      player.removeAttribute('src');
      while (player.firstChild) player.removeChild(player.firstChild);
      try { player.load(); } catch (error) { /* load resets the element */ }
      player.hidden = true;
      if (embed) {
        embed.replaceChildren();
        embed.hidden = true;
      }
    }

    function showPoster(video) {
      var posterUrl = safeImageUrl(video && video.poster);
      if (!posterUrl) {
        poster.removeAttribute('src');
        poster.hidden = true;
        playButton.hidden = false;
        return;
      }
      if (!poster.parentNode) frame.insertBefore(poster, frame.firstChild);
      if (poster.getAttribute('src') !== posterUrl) poster.setAttribute('src', posterUrl);
      poster.hidden = false;
      playButton.hidden = false;
    }

    function attachFile(video) {
      var fileUrl = safeFileUrl(video.source && video.source.url);
      if (!fileUrl) {
        showError();
        return;
      }
      var source = document.createElement('source');
      source.src = fileUrl;
      if (video.source.mime) source.type = video.source.mime;
      player.preload = 'none';
      player.playsInline = true;
      player.controls = true;
      player.loop = false;
      player.hidden = false;
      poster.hidden = true;
      playButton.hidden = true;
      player.appendChild(source);
      player.onerror = showError;
      player.load();
      var attempt = player.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function () {
          playButton.hidden = false;
          player.hidden = false;
        });
      }
    }

    function attachExternal(video) {
      var source = video.source || {};
      var embedUrl = externalEmbedUrl(source.host, source.externalId);
      if (!embedUrl || !embed) {
        showError();
        return;
      }
      var iframe = document.createElement('iframe');
      iframe.src = embedUrl;
      iframe.title = video.title || root.dataset.labelPlay || 'Video';
      iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
      iframe.allowFullscreen = true;
      iframe.setAttribute('playsinline', '');
      embed.appendChild(iframe);
      embed.hidden = false;
      poster.hidden = true;
      playButton.hidden = true;
    }

    function startPlayback() {
      var video = videos[current];
      stopMedia();
      hideError();
      pauseInlineGallery();
      document.dispatchEvent(new Event('gt:product-video-play'));
      if (!video || !video.source || video.source.kind === 'unavailable') {
        showError();
        return;
      }
      if (video.source.kind === 'file') attachFile(video);
      else if (video.source.kind === 'external') attachExternal(video);
      else showError();
    }

    function updateArrows() {
      if (!scroller || !prevButton || !nextButton) return;
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      var overflows = maxScroll > 8;
      prevButton.hidden = !overflows;
      nextButton.hidden = !overflows;
      prevButton.disabled = scroller.scrollLeft <= 4;
      nextButton.disabled = scroller.scrollLeft >= maxScroll - 4;
    }

    function updateSelected() {
      choiceButtons.forEach(function (button, index) {
        var selected = index === current;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        var state = button.querySelector('[data-gt-selected-label]');
        if (state) state.hidden = !selected;
      });
      var selectedButton = choiceButtons[current];
      if (selectedButton && scroller && window.matchMedia('(min-width: 768px)').matches) {
        var target = selectedButton.offsetLeft - ((scroller.clientWidth - selectedButton.offsetWidth) / 2);
        scroller.scrollTo({ left: Math.max(0, target), behavior: reducedBehavior() });
      }
      updateArrows();
    }

    function selectVideo(index, shouldPlay) {
      if (index < 0 || index >= videos.length) return;
      current = index;
      var video = videos[index];
      stopMedia();
      hideError();
      frame.style.setProperty('--gt-video-aspect', String(aspectRatio(video)));
      if (titleEl) titleEl.textContent = video.title || '';
      if (positionEl) {
        positionEl.textContent = formatPosition(root.dataset.labelPosition, index + 1, videos.length);
      }
      showPoster(video);
      updateSelected();
      if (shouldPlay) startPlayback();
    }

    var thumbObserver = null;
    function observeThumb(image, url) {
      if (!('IntersectionObserver' in window)) {
        image.src = url;
        return;
      }
      if (!thumbObserver) {
        thumbObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var img = entry.target;
            if (!img.getAttribute('src')) img.src = img.dataset.gtThumb;
            thumbObserver.unobserve(img);
          });
        }, { rootMargin: '160px' });
      }
      image.dataset.gtThumb = url;
      thumbObserver.observe(image);
    }

    function buildChoices() {
      if (choicesBuilt || !scroller) return;
      choicesBuilt = true;
      videos.forEach(function (video, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'gt-product-videos__choice';
        button.setAttribute('aria-pressed', 'false');
        var media = document.createElement('span');
        media.className = 'gt-product-videos__choice-media';
        var thumb = safeImageUrl(video.thumb);
        if (thumb) {
          var image = document.createElement('img');
          image.alt = '';
          image.loading = 'lazy';
          image.decoding = 'async';
          image.width = 160;
          image.height = 90;
          media.appendChild(image);
          observeThumb(image, thumb);
        }
        var copy = document.createElement('span');
        copy.className = 'gt-product-videos__choice-copy';
        var label = document.createElement('span');
        label.className = 'gt-product-videos__choice-title';
        label.textContent = video.title || '';
        var state = document.createElement('span');
        state.className = 'gt-product-videos__choice-state';
        state.dataset.gtSelectedLabel = 'true';
        state.textContent = root.dataset.labelSelected || 'Selected';
        state.hidden = true;
        copy.appendChild(label);
        copy.appendChild(state);
        button.appendChild(media);
        button.appendChild(copy);
        button.addEventListener('click', function () {
          selectVideo(index, true);
        });
        scroller.appendChild(button);
        choiceButtons.push(button);
      });
    }

    function moveDialogToBody() {
      if (dialog.parentNode !== document.body) document.body.appendChild(dialog);
    }

    function restoreDialog() {
      if (!dialogHome) return;
      if (dialogNext && dialogNext.parentNode === dialogHome) dialogHome.insertBefore(dialog, dialogNext);
      else dialogHome.appendChild(dialog);
    }

    function close() {
      if (!isOpen && !dialog.open) return;
      isOpen = false;
      root.removeAttribute('data-gt-open');
      stopMedia();
      hideError();
      if (dialog.open) dialog.close();
      restoreDialog();
      unlockScroll();
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      lastFocus = null;
    }

    function open() {
      if (isOpen) return;
      stopOpenViewers(root);
      pauseInlineGallery();
      lastFocus = document.activeElement;
      buildChoices();
      selectVideo(0, false);
      moveDialogToBody();
      lockScroll();
      isOpen = true;
      root.setAttribute('data-gt-open', 'true');
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      closeButton.focus();
      updateArrows();
    }

    function onLaunchClick(event) {
      event.preventDefault();
      event.stopPropagation();
      open();
    }

    function onDialogClick(event) {
      if (event.target === dialog) close();
    }

    function onDialogClose() {
      if (isOpen) close();
    }

    function onEscape(event) {
      if (!isOpen || event.key !== 'Escape' || document.fullscreenElement) return;
      event.preventDefault();
      close();
    }

    function onKeydown(event) {
      if (!scroller || !scroller.contains(event.target)) return;
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      event.preventDefault();
      var forward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
      var next = current + (forward ? 1 : -1);
      if (next < 0 || next >= videos.length) return;
      selectVideo(next, true);
      if (choiceButtons[next]) choiceButtons[next].focus();
    }

    function onScrollClick(event) {
      var button = event.currentTarget;
      if (!scroller) return;
      var delta = button.getAttribute('data-gt-video-scroll') === 'prev' ? -240 : 240;
      scroller.scrollBy({ left: delta, behavior: reducedBehavior() });
    }

    launch.addEventListener('click', onLaunchClick);
    closeButton.addEventListener('click', close);
    playButton.addEventListener('click', function () {
      startPlayback();
    });
    if (retry) retry.addEventListener('click', startPlayback);
    dialog.addEventListener('click', onDialogClick);
    dialog.addEventListener('close', onDialogClose);
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      close();
    });
    document.addEventListener('keydown', onEscape);
    if (scroller) scroller.addEventListener('keydown', onKeydown);
    if (scroller) scroller.addEventListener('scroll', updateArrows);
    if (prevButton) prevButton.addEventListener('click', onScrollClick);
    if (nextButton) nextButton.addEventListener('click', onScrollClick);
    window.addEventListener('resize', updateArrows);

    var controller = {
      close: close,
      stopMedia: stopMedia,
      destroy: function () {
        if (root.dataset.gtBound !== 'true') return;
        close();
        if (thumbObserver) thumbObserver.disconnect();
        launch.removeEventListener('click', onLaunchClick);
        closeButton.removeEventListener('click', close);
        dialog.removeEventListener('click', onDialogClick);
        dialog.removeEventListener('close', onDialogClose);
        document.removeEventListener('keydown', onEscape);
        window.removeEventListener('resize', updateArrows);
        root.dataset.gtBound = 'false';
        root.__gtApi = null;
      }
    };
    root.__gtApi = controller;
    dialog.__gtApi = controller;
  }

  function ensureStylesheet(root) {
    var href = root && root.getAttribute('data-gt-video-css');
    if (!href || !document.head) return;
    var links = document.head.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < links.length; i++) {
      var current = links[i].getAttribute('href') || '';
      if (current.indexOf('product-video-viewer.css') !== -1) return;
    }
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-gt-video-css', 'true');
    document.head.appendChild(link);
  }

  function collectVideoRoots(node, bucket) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches('[data-gt-product-videos]')) bucket.push(node);
    if (!node.querySelectorAll) return;
    node.querySelectorAll('[data-gt-product-videos]').forEach(function (root) {
      bucket.push(root);
    });
  }

  function watchInjectedViewers() {
    if (!window.MutationObserver || document.documentElement.dataset.gtVideoWatch === 'true') return;
    document.documentElement.dataset.gtVideoWatch = 'true';
    var observer = new MutationObserver(function (mutations) {
      var needsScan = false;
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.removedNodes, function (node) {
          var roots = [];
          collectVideoRoots(node, roots);
          roots.forEach(function (root) {
            if (root.__gtApi) root.__gtApi.destroy();
          });
        });
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          var roots = [];
          collectVideoRoots(node, roots);
          if (roots.length) needsScan = true;
        });
      });
      if (needsScan) scan();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function scan() {
    document.querySelectorAll('[data-gt-product-videos]').forEach(mountRoot);
  }

  function onSectionLoad() {
    scan();
  }

  function onSectionUnload(event) {
    var sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;
    var section = document.getElementById('shopify-section-' + sectionId);
    if (section) {
      section.querySelectorAll('[data-gt-product-videos]').forEach(function (root) {
        if (root.__gtApi) root.__gtApi.destroy();
      });
    }
    document.querySelectorAll('[data-gt-video-dialog][data-section-id="' + sectionId + '"]').forEach(function (dialog) {
      if (dialog.__gtApi) dialog.__gtApi.destroy();
    });
  }

  function onGalleryPlay(event) {
    var target = event.target;
    if (!target || !target.closest || !target.closest('[data-product-gallery]')) return;
    document.querySelectorAll('[data-gt-product-videos][data-gt-open="true"]').forEach(function (root) {
      if (root.__gtApi) root.__gtApi.stopMedia();
    });
  }

  function mount() {
    if (window.__gtProductVideoViewer) {
      watchInjectedViewers();
      window.__gtProductVideoViewer.scan();
      return;
    }
    window.__gtProductVideoViewer = { scan: scan };
    watchInjectedViewers();
    if (!documentListeners) {
      documentListeners = true;
      document.addEventListener('shopify:section:load', onSectionLoad);
      document.addEventListener('shopify:section:unload', onSectionUnload);
      document.addEventListener('play', onGalleryPlay, true);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }
  }

  return {
    sanitizeExternalId: sanitizeExternalId,
    externalEmbedUrl: externalEmbedUrl,
    formatPosition: formatPosition,
    aspectRatio: aspectRatio,
    safeImageUrl: safeImageUrl,
    safeFileUrl: safeFileUrl,
    mount: mount
  };
});